var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudiance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 9.79684C13.8768 9.79684 15.3983 8.27532 15.3983 6.39842C15.3983 4.52152 13.8768 3 11.9999 3C10.123 3 8.6015 4.52152 8.6015 6.39842C8.6015 8.27532 10.123 9.79684 11.9999 9.79684Z",
    fill: "#0350A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8749 9.7968C20.0615 9.7968 21.0234 8.83492 21.0234 7.64838C21.0234 6.46183 20.0615 5.49995 18.8749 5.49995C17.6884 5.49995 16.7265 6.46183 16.7265 7.64838C16.7265 8.83492 17.6884 9.7968 18.8749 9.7968Z",
    fill: "#0350A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12493 9.7968C6.31147 9.7968 7.27336 8.83492 7.27336 7.64838C7.27336 6.46183 6.31147 5.49995 5.12493 5.49995C3.93838 5.49995 2.9765 6.46183 2.9765 7.64838C2.9765 8.83492 3.93838 9.7968 5.12493 9.7968Z",
    fill: "#0350A2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24171 11.7261C6.39601 11.0332 5.63012 11.125 4.65227 11.125C3.18978 11.125 1.99994 12.3078 1.99994 13.7613V18.0273C1.99994 18.6585 2.51517 19.1718 3.14876 19.1718C5.88414 19.1718 5.55461 19.2213 5.55461 19.0538C5.55461 16.031 5.19656 13.8141 7.24171 11.7261Z",
    fill: "#0350A2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9302 11.1405C11.2223 10.9981 9.7377 11.1422 8.4572 12.1991C6.31436 13.9155 6.72674 16.2266 6.72674 19.0538C6.72674 19.8018 7.33533 20.4218 8.0947 20.4218C16.3401 20.4218 16.6682 20.6877 17.1572 19.605C17.3175 19.2388 17.2736 19.3552 17.2736 15.8522C17.2736 13.07 14.8645 11.1405 12.9302 11.1405Z",
    fill: "#0350A2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3476 11.1249C18.3644 11.1249 17.6027 11.0341 16.7581 11.7261C18.788 13.7986 18.4452 15.8641 18.4452 19.0538C18.4452 19.2223 18.1717 19.1717 20.8101 19.1717C21.4663 19.1717 21.9999 18.6401 21.9999 17.9866V13.7612C21.9999 12.3077 20.8101 11.1249 19.3476 11.1249Z",
    fill: "#0350A2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudiance);
export default __webpack_public_path__ + "static/media/audiance.f52b9d32e4935e72e24b0659a1181916.svg";
export { ForwardRef as ReactComponent };